<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'contatosCrud'"
          crudName="Contatos"
          newText="Novo Contato"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="false"
          :enableEdit="true"
          :enableDelete="false"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
          <div slot="bloqueado" slot-scope="props">
            <span v-if="props.row.bloqueado" class="badge badge-danger">Bloqueado</span>
            <span v-else class="badge badge-success">Liberado</span>
          </div>
          <div slot="status" slot-scope="props">
            <span v-if="props.row.status == 1" class="badge badge-success">Ativo</span>
            <span v-else class="badge badge-secondary">Inativo</span>
          </div>
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "contatosTable",
      columns: ["id", "wa_id", "nome", "bloqueado", "status", "actions"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: [],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          wa_id: "Número",
          nome: "Nome",
          bloqueado: "Bloqueio",
          status: "Status",
          actions: "Ações",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {},
        templates: {},
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "contatos/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        wa_id: "wa_id",
        nome: "nome",
        status: "status",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>
